<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6 3v18a1 1 0 001 1 1 1 0 001-1v-7.36l10.41-4.73a1 1 0 000-1.82l-11-5A1 1 0 006 3zm2 1.55L15.58 8 8 11.45z"/></svg>